const MBB_ADMIN_WEB = '/mbb-admin-web';

export const ROUTE_HOME_MBB_ADMIN_WEB = MBB_ADMIN_WEB + '/home';
export const ROUTE_VEHICLE_DATA = MBB_ADMIN_WEB + '/vehicleData';

export const mbbAdminWebRoutes = [ROUTE_HOME_MBB_ADMIN_WEB, ROUTE_VEHICLE_DATA];